import React from "react";
import { EditorState, Modifier } from "draft-js";
import style from "./style.css";
import { Flex } from "/app/src/component";
import Emoji from "/app/src/component/Emoji";

export default class EmojiOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
    this._addEmoji = this._addEmoji.bind(this);
  }
  componentWillMount() {
    const { modalHandler } = this.props;
    modalHandler.registerCallBack(this.expandCollapse);
  }
  componentWillUnmount() {
    const { modalHandler } = this.props;
    modalHandler.deregisterCallBack(this.expandCollapse);
  }
  onExpandEvent = () => {
    this.signalExpanded = !this.state.expanded;
  };

  expandCollapse = () => {
    this.setState({
      expanded: this.signalExpanded
    });
    this.signalExpanded = false;
  };

  doExpand = () => {
    this.setState({
      expanded: true
    });
  };

  doCollapse = () => {
    this.setState({
      expanded: false
    });
  };

  _addEmoji(text) {
    const { editorState, onChange } = this.props;
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      text,
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, "insert-characters"));
  }

  renderModal() {
    const lst = [
      "🙂",
      "😃",
      "😄",
      "😐",
      "😦",
      "😔",
      "😬",
      "🤔",
      "😫",
      "😤",
      "😠",
      "👋",
      "👌",
      "👍",
      "👎",
      "🤝"
    ];

    let emojiWidth = 2;
    let emojiHeight = 2;
    let emojiPadding = 0.2;
    return (

      <Flex grow wrap className={style.SmileyModalContainer} style={{width: `${4*(emojiPadding*2+emojiWidth)}em`}}>
        {lst.map((text, index) => {
          return (
            <Emoji key={index} unicodeEmoji={text} onClick={_ => this._addEmoji(text)} padding={`${emojiPadding}em ${emojiPadding}em ${emojiPadding}em ${emojiPadding}em`} width={`${emojiWidth}em`} height={`${emojiHeight}em`}></Emoji>
          );
        })}
      </Flex>
    );
  }

  render() {
    return (
      <div
        aria-haspopup="true"
        className="rdw-emoji-wrapper"
        style={{ cursor: "pointer" }}
        onClick={this.onExpandEvent}
      >
        <img
          src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjE1LjcyOSAyMi4wODIgMTcgMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5LjcwOCAyNS4xMDRjLTMuMDIxLTMuMDIyLTcuOTM3LTMuMDIyLTEwLjk1OCAwLTMuMDIxIDMuMDItMy4wMiA3LjkzNiAwIDEwLjk1OCAzLjAyMSAzLjAyIDcuOTM3IDMuMDIgMTAuOTU4LS4wMDEgMy4wMi0zLjAyMSAzLjAyLTcuOTM2IDAtMTAuOTU3em0tLjg0NSAxMC4xMTJhNi41NiA2LjU2IDAgMCAxLTkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAtOS4yNjcgNi41NiA2LjU2IDAgMCAxIDkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAgOS4yNjd6bS03LjUyNC02LjczYS45MDYuOTA2IDAgMSAxIDEuODExIDAgLjkwNi45MDYgMCAwIDEtMS44MTEgMHptNC4xMDYgMGEuOTA2LjkwNiAwIDEgMSAxLjgxMiAwIC45MDYuOTA2IDAgMCAxLTEuODEyIDB6bTIuMTQxIDMuNzA4Yy0uNTYxIDEuMjk4LTEuODc1IDIuMTM3LTMuMzQ4IDIuMTM3LTEuNTA1IDAtMi44MjctLjg0My0zLjM2OS0yLjE0N2EuNDM4LjQzOCAwIDAgMSAuODEtLjMzNmMuNDA1Ljk3NiAxLjQxIDEuNjA3IDIuNTU5IDEuNjA3IDEuMTIzIDAgMi4xMjEtLjYzMSAyLjU0NC0xLjYwOGEuNDM4LjQzOCAwIDAgMSAuODA0LjM0N3oiLz48L3N2Zz4="
          alt="emoji"
        />
        {this.state.expanded ? this.renderModal() : undefined}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Markdown/EmojiOption.jsx